import type { ReactNode } from "react";
import styled from "styled-components";
import SideNav from "./SideNav";
import { PAGE_MAX_WIDTH, SIDE_NAV_WIDTH } from "./constants";

const Page = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.depthLight3};
  isolation: isolate;
`;

/* Sivupalkki on kiinni ikkunan vasemmassa, ylä- ja alareunassa
   (top/left/bottom = 0). Yhtenäinen 15px (s-token) gap kaikkialla:
   sivupalkin oikealla, sisältöalueen oikealla, alalaidassa ja ylälaidassa.
   Yläpalkki poistettu kokonaan — käyttäjäidentiteetti ja proto-banneri ovat
   sivupalkin sisällä. */
const Main = styled.main`
  margin-left: calc(${SIDE_NAV_WIDTH} + ${({ theme }) => theme.spacing.s});
  padding-top: ${({ theme }) => theme.spacing.s};
  min-height: 100vh;
`;

/* Container symmetrisillä paddingseillä, oikealla ja pohjassa.
   Vasen padding 0, koska Main:n margin-left hoitaa jo gap:n sivupalkista. */
const Content = styled.div`
  padding: 0 ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.s}
    0;
  max-width: ${PAGE_MAX_WIDTH};
`;

export default function AppShell({ children }: { children: ReactNode }) {
  return (
    <Page>
      <SideNav />
      <Main>
        <Content>{children}</Content>
      </Main>
    </Page>
  );
}
